import * as ImportConstants from '../../action/import/ImportConstants';

const initialState = {
  getImportFormatIsLoading: false,
  getImportFormatData: {},
  getImportFormatErrorMessage: '',

  loadUpdatedIsLoading: false,
  loadUpdatedResponse: {},
  loadUpdatedErrorMessage: '',

  loadImportedIsLoading: false,
  loadImportedResponse: {},
  loadImportedErrorMessage: ''
};

export const importStore = (state = initialState, action) => {
  switch (action.type) {
    case ImportConstants.GET_FORMAT_REQUEST:
      return {
        ...state,
        getImportFormatIsLoading: true,
        getImportFormatErrorMessage: ''
      };
    case ImportConstants.GET_FORMAT_SUCCESS:
      return {
        ...state,
        getImportFormatIsLoading: false,
        getImportFormatData: action.data
      };
    case ImportConstants.GET_FORMAT_FAILED:
      return {
        ...state,
        getImportFormatIsLoading: false,
        getImportFormatErrorMessage: 'SERVER ERROR'
      };

    case ImportConstants.LOAD_UPDATE_REQUEST:
      return {
        ...state,
        loadUpdatedIsLoading: true,
        loadUpdatedErrorMessage: ''
      };
    case ImportConstants.LOAD_UPDATE_SUCCESS:
      return {
        ...state,
        loadUpdatedIsLoading: false,
        loadUpdatedResponse: action.data
      };
    case ImportConstants.LOAD_UPDATE_FAILED:
      return {
        ...state,
        loadUpdatedIsLoading: false,
        loadUpdatedErrorMessage: action.error?.response?.data || action.error?.message || 'SERVER ERROR'
      };

    case ImportConstants.LOAD_IMPORT_REQUEST:
      return {
        ...state,
        loadImportIsLoading: true,
        loadImportedErrorMessage: '',
        loadImportedResponse: {}
      };
    case ImportConstants.LOAD_IMPORT_SUCCESS:
      return {
        ...state,
        loadImportedIsLoading: false,
        loadImportedResponse: action.data
      };
    case ImportConstants.LOAD_IMPORT_FAILED:
      return {
        ...state,
        loadImportedIsLoading: false,
        loadImportedErrorMessage: action.error?.response?.data || action.error?.message || 'SERVER ERROR',
        loadImportedResponse: {}
      };

    default:
      return state;
  }
};
